"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UINanoProgress = _interopRequireDefault(require("UIComponents/progress/UINanoProgress"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIMediaLeft = _interopRequireDefault(require("UIComponents/layout/UIMediaLeft"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var ThumbnailSizes = _interopRequireWildcard(require("FileManagerCore/enums/ThumbnailSizes"));

var _file = require("FileManagerCore/utils/file");

var _thumbnailTooltip = require("FileManagerCore/utils/thumbnailTooltip");

var _FileTypeIcon = _interopRequireDefault(require("FileManagerCore/components/FileTypeIcon"));

var _VideoIconOverlay = _interopRequireDefault(require("FileManagerCore/components/VideoIconOverlay"));

var _fileNameAndExtension = require("../../utils/fileNameAndExtension");

var _Constants = require("../../Constants");

var StyledHoverButtons = (0, _styledComponents.default)(_UIMediaRight.default).withConfig({
  displayName: "FileRowTile__StyledHoverButtons",
  componentId: "sc-1r5ubhm-0"
})(["display:none;"]);

var StyledFileRowTile = _styledComponents.default.div.withConfig({
  displayName: "FileRowTile__StyledFileRowTile",
  componentId: "sc-1r5ubhm-1"
})(["display:flex;align-items:center;height:100%;width:100%;cursor:pointer;border:1px solid ", ";border-bottom:", ";&:hover{background-color:", ";}&:hover ", "{display:block;}", ""], _colors.KOALA, function (props) {
  return props.isLast ? "1px solid " + _colors.KOALA : 'none';
}, _colors.CALYPSO_LIGHT, StyledHoverButtons, function (props) {
  return props.isSelected && "\n    background-color: " + _colors.KOALA + ";\n    " + StyledHoverButtons + " {\n      display: block;\n    }";
});

var StyledMedia = (0, _styledComponents.default)(_UIMedia.default).withConfig({
  displayName: "FileRowTile__StyledMedia",
  componentId: "sc-1r5ubhm-2"
})(["width:100%;"]);

var StyledThumbnailImage = _styledComponents.default.img.withConfig({
  displayName: "FileRowTile__StyledThumbnailImage",
  componentId: "sc-1r5ubhm-3"
})(["max-width:", "px;max-height:", "px;opacity:", ";"], _Constants.FILE_FOLDER_THUMB_SIZE, _Constants.FILE_FOLDER_THUMB_SIZE, function (props) {
  return props.disabled ? 0.5 : 1;
});

var StyledUploadingOverlay = _styledComponents.default.div.withConfig({
  displayName: "FileRowTile__StyledUploadingOverlay",
  componentId: "sc-1r5ubhm-4"
})(["position:absolute;width:100%;height:100%;opacity:0.5;cursor:progress;background-color:", ";z-index:1;"], _colors.OLAF);

var FileRowTile = function FileRowTile(_ref) {
  var file = _ref.file,
      isSelected = _ref.isSelected,
      isLast = _ref.isLast,
      isHostAppContextPrivate = _ref.isHostAppContextPrivate,
      onInsert = _ref.onInsert,
      onSelect = _ref.onSelect;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      errorLoadingThumbnail = _useState2[0],
      setErrorLoadingThumbnail = _useState2[1];

  var thumbnailTitle = (0, _fileNameAndExtension.getFileNameAndExtension)(file);
  var isUploading = file.has('progress');
  var isInsertDisabled = Boolean(file.get('notSupported'));
  var showTooltip = isInsertDisabled || errorLoadingThumbnail || !(0, _thumbnailTooltip.getIsThumbnailTooltipDisabled)(file);

  var handleClickDetails = function handleClickDetails(e) {
    e.stopPropagation();

    if (isSelected) {
      onSelect(null, {
        target: 'file-row-details-button'
      });
    } else {
      onSelect(file, {
        target: 'file-row-details-button'
      });
    }
  };

  var handleRowClick = function handleRowClick() {
    if (isSelected) {
      onSelect(null, {
        target: 'file-row'
      });
    } else {
      onSelect(file, {
        target: 'file-row'
      });
    }
  };

  var handleInsert = function handleInsert(e) {
    e.stopPropagation();
    onInsert(file, {
      target: 'file-row'
    });
  };

  var handleImageLoadError = function handleImageLoadError() {
    if (!errorLoadingThumbnail) {
      setErrorLoadingThumbnail(true);
    }
  };

  var renderThumbnail = function renderThumbnail() {
    return _react.default.createElement("div", {
      className: "align-center justify-center text-center"
    }, _react.default.createElement(StyledThumbnailImage, {
      alt: thumbnailTitle,
      draggable: false,
      onError: handleImageLoadError,
      disabled: isInsertDisabled,
      src: (0, _file.getImageSrc)(file, ThumbnailSizes.THUMB, {
        isFallbackImageDisabled: true
      })
    }), (0, _file.getIsVideo)(file) && _react.default.createElement(_VideoIconOverlay.default, null));
  };

  var renderFileTypeIcon = function renderFileTypeIcon() {
    return _react.default.createElement(_FileTypeIcon.default, {
      color: _colors.EERIE,
      size: 32,
      file: file,
      draggable: false
    });
  };

  var renderDetailsButton = function renderDetailsButton() {
    return _react.default.createElement(StyledHoverButtons, null, _react.default.createElement(_UIButton.default, {
      className: "details-button",
      size: "extra-small",
      use: "tertiary-light",
      onClick: handleClickDetails,
      "data-test-id": "file-row-details-button"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "FileManagerLib.actions.fileDetail"
    })));
  };

  return _react.default.createElement(StyledFileRowTile, {
    isSelected: isSelected,
    isLast: isLast,
    onClick: handleRowClick,
    "data-test-id": "file-row"
  }, isUploading && _react.default.createElement(StyledUploadingOverlay, null, _react.default.createElement(_UINanoProgress.default, {
    color: _colors.CALYPSO,
    value: file.get('progress')
  })), _react.default.createElement(_UITooltip.default, {
    disabled: !showTooltip,
    title: file.get('notSupportedReason') || _react.default.createElement(_FormattedMessage.default, {
      message: (0, _thumbnailTooltip.getThumbnailTooltipI18nKey)(file, isHostAppContextPrivate)
    }),
    placement: "bottom"
  }, _react.default.createElement(StyledMedia, {
    align: "center",
    className: "p-x-2"
  }, _react.default.createElement(_UIMediaLeft.default, {
    style: {
      width: _Constants.FILE_FOLDER_THUMB_SIZE
    }
  }, (0, _file.getHasThumbnail)(file) && !errorLoadingThumbnail ? renderThumbnail(file) : renderFileTypeIcon(file)), _react.default.createElement(_UIMediaBody.default, {
    className: "align-center"
  }, _react.default.createElement(_UILink.default, {
    onClick: handleInsert,
    disabled: isInsertDisabled
  }, _react.default.createElement(_UITruncateString.default, null, thumbnailTitle))), !isUploading && renderDetailsButton())));
};

FileRowTile.propTypes = {
  isSelected: _propTypes.default.bool.isRequired,
  isLast: _propTypes.default.bool.isRequired,
  file: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  isHostAppContextPrivate: _propTypes.default.bool.isRequired
};

var _default = (0, _react.memo)(FileRowTile);

exports.default = _default;
module.exports = exports.default;